export default __webpack_public_path__ + "static/LogoS-d0ce9412a543e2714ee6eeabf674b57b.png";